<siat-loading-spinner [visible]="isSending()"></siat-loading-spinner>

<div class="flex! justify-between!">
  <h4 class="pt-0" mat-dialog-title>Supporto</h4>
  <button
    matIconButton
    type="button"
    class="mt-4 mr-3"
    [disabled]="isSending()"
    (click)="activeModal.close()"
    aria-label="Chiudi"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="pt-0!" [attr.inert]="isSending() ? '' : null">
  <div class="rounded-md border border-gray-200 bg-gray-50 p-4 mb-6 text-sm">
    <p class="font-semibold mt-0">Come compilare la richiesta</p>
    <p class="mb-0">
      Inserisci un recapito telefonico e/o e-mail e identifica il paziente
      tramite <strong>codice fiscale</strong> oppure
      <strong>cognome e nome</strong>. Descrivi il problema riscontrato nel modo
      più dettagliato possibile, quindi indica il
      <strong>dispositivo utilizzato</strong> e la
      <strong>data in cui si è verificato il problema</strong>.
    </p>
  </div>

  <form
    [formGroup]="form"
    class="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-5 pt-2"
  >
    <siat-input-field
      [formGroup]="form"
      controlName="phone"
      id="phone"
      name="phone"
      label="Telefono"
      placeholder="Inserisci il telefono"
    ></siat-input-field>
    <siat-input-field
      [formGroup]="form"
      controlName="email"
      id="email"
      name="email"
      type="email"
      label="Email"
      placeholder="Inserisci l'email"
    ></siat-input-field>
    @if (showContattoError) {
      <p class="md:col-span-2 text-danger text-sm -mt-3 mb-0">
        Inserisci almeno un recapito tra telefono ed email.
      </p>
    }

    <div class="md:col-span-2">
      <siat-radio-field
        [formGroup]="form"
        controlName="identificazione"
        id="identificazione"
        name="identificazione"
        label="Identificazione paziente"
        [data]="identificazioneItems"
      ></siat-radio-field>
    </div>

    @if (identificazione() === 'codiceFiscale') {
      <div class="md:col-span-2">
        <siat-input-field
          [formGroup]="form"
          controlName="patientFiscalcode"
          id="patientFiscalcode"
          name="patientFiscalcode"
          label="Codice fiscale del paziente"
          placeholder="Inserisci il codice fiscale"
          [maxlength]="16"
        ></siat-input-field>
      </div>
    } @else {
      <siat-input-field
        [formGroup]="form"
        controlName="patientLastName"
        id="patientLastName"
        name="patientLastName"
        label="Cognome del paziente"
        placeholder="Inserisci il cognome"
      ></siat-input-field>
      <siat-input-field
        [formGroup]="form"
        controlName="patientFirstName"
        id="patientFirstName"
        name="patientFirstName"
        label="Nome del paziente"
        placeholder="Inserisci il nome"
      ></siat-input-field>
    }

    <siat-select-tipologica-field
      [formGroup]="form"
      controlName="ticketType"
      id="ticketType"
      name="ticketType"
      label="Tipo ticket"
      placeholder="Seleziona il tipo di ticket"
      endpoint="tipo_ticket_redmine"
    ></siat-select-tipologica-field>
    <siat-select-tipologica-field
      [formGroup]="form"
      controlName="ticketSystem"
      id="ticketSystem"
      name="ticketSystem"
      label="Sistema"
      placeholder="Seleziona il sistema"
      endpoint="sistema_ticket_redmine"
    ></siat-select-tipologica-field>

    <div class="md:col-span-2">
      <siat-textarea-field
        [formGroup]="form"
        controlName="problemDescription"
        id="problemDescription"
        name="problemDescription"
        label="Descrizione del problema"
        placeholder="Inserisci la descrizione del problema"
        [rows]="3"
      ></siat-textarea-field>
    </div>

    <div class="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-5">
      <siat-select-field
        [formGroup]="form"
        controlName="device"
        id="device"
        label="Dispositivo"
        [items]="dispositivoItems"
      ></siat-select-field>
      @if (dispositivo() === 'App') {
        <siat-radio-field
          [formGroup]="form"
          controlName="deviceType"
          id="deviceType"
          name="deviceType"
          label="Sistema operativo"
          [data]="sistemaOperativoItems"
          [displayInline]="true"
        ></siat-radio-field>
      }
    </div>

    <siat-datepicker-field
      [formGroup]="form"
      controlName="data"
      id="data"
      name="data"
      label="Data del problema"
      placeholder="Seleziona la data del problema"
      [maxDate]="maxDate"
    ></siat-datepicker-field>
    <siat-timepicker-field
      [formGroup]="form"
      controlName="ora"
      id="ora"
      name="ora"
      label="Ora del problema"
      placeholder="Seleziona l'ora del problema"
      [maxTime]="maxTime()"
      floatLabel="always"
    ></siat-timepicker-field>

    <div class="md:col-span-2 [&_.upload-file]:mx-0!">
      <siat-upload-file
        formControlName="allegati"
        id="allegati"
        name="allegati"
        label="Allegati"
        listPosition="above"
      ></siat-upload-file>
    </div>
  </form>
</mat-dialog-content>

<div mat-dialog-actions class="flex justify-end gap-3 mt-4">
  <button
    matButton="outlined"
    type="button"
    class="whitespace-nowrap"
    [disabled]="isSending()"
    (click)="activeModal.close()"
  >
    Chiudi
  </button>
  <button
    matButton="filled"
    type="button"
    class="whitespace-nowrap"
    [disabled]="form.invalid || isSending()"
    (click)="sendTicket()"
  >
    Invia segnalazione
  </button>
</div>
